import type { FaireProductEntity } from "../../entity_types/product";

export const p_p5pskp89vt: FaireProductEntity = {
  token: "p_p5pskp89vt",
  type: "product",
  name: "Sex Serum",
  brandToken: "b_phyk4zwbt3",
  brandName: "Mienne",
  imageUrl:
    "https://cdn.faire.com/fastly/fec4e5d67b37625429a639cb61f5f7dab1110b99ed343ab3a4be896acf714a90.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/893490bd19bdf6661294f759fd0df8f96ac417c365823d00837e2ed3d6ef0f1a.jpeg",
    "https://cdn.faire.com/fastly/34e66cb8b9ced8fdb58ac694fae8dfffe84ae4d22cc74be245bb297180ef5c65.jpeg",
    "https://cdn.faire.com/fastly/b6f56ce64a3c68bb2f3ead95dbc0bce77e92d4909611208ba8e2f07c4baa4fd6.jpeg",
    "https://cdn.faire.com/fastly/d7ca9d025a18477cc185c1bbfed330c26e4c4e714e451dfb4c47162dae0eac13.jpeg",
    "https://cdn.faire.com/fastly/2d49de4c0cf15f2897ad23caf0ac6a6100e7cbc58d4ea93f570b45504da7e23e.jpeg",
  ],
  priceDollars: 15.75,
  description:
    "A water-based, silicone-free serum that delivers lasting comfort and deep hydration without stickiness or residue. Infused with Hyaluronic Acid to draw in moisture, calming Aloe to soothe, and mood-shifting Adaptogens to heighten connection through the senses, it moves effortlessly with the body to enhance pleasure and intimacy. pH-balanced, fragrance-free, and gynecologist and dermatologist tested.\n",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:32:36.030Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
